import React, { useState, useEffect } from 'react';
import { db, collection, getDocs, addDoc, deleteDoc, doc, updateDoc } from '../utils/firebase';
import LogoutButton from '../components/LogoutButton';
import './Voucher.css';

const Voucher = () => {
  const [vouchers, setVouchers] = useState([]);
  const [newVoucher, setNewVoucher] = useState({
    code: '',
    discount: '',
    expiryDate: '',
    status: 'active'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchVouchers();
  }, []);

  const fetchVouchers = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, 'vouchers'));
      const voucherList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setVouchers(voucherList);
    } catch (err) {
      setError('Failed to fetch vouchers');
      console.error('Error fetching vouchers:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewVoucher(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddVoucher = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await addDoc(collection(db, 'vouchers'), {
        ...newVoucher,
        createdAt: new Date().toISOString()
      });
      setNewVoucher({
        code: '',
        discount: '',
        expiryDate: '',
        status: 'active'
      });
      fetchVouchers();
    } catch (err) {
      setError('Failed to add voucher');
      console.error('Error adding voucher:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteVoucher = async (id) => {
    if (window.confirm('Are you sure you want to delete this voucher?')) {
      try {
        setLoading(true);
        await deleteDoc(doc(db, 'vouchers', id));
        fetchVouchers();
      } catch (err) {
        setError('Failed to delete voucher');
        console.error('Error deleting voucher:', err);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    try {
      setLoading(true);
      const voucherRef = doc(db, 'vouchers', id);
      await updateDoc(voucherRef, {
        status: currentStatus === 'active' ? 'inactive' : 'active'
      });
      fetchVouchers();
    } catch (err) {
      setError('Failed to update voucher status');
      console.error('Error updating voucher status:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="voucher-container">
      <LogoutButton />
      <h1>Voucher Management</h1>
      
      {error && <div className="error-message">{error}</div>}
      
      <div className="voucher-form">
        <h2>Add New Voucher</h2>
        <form onSubmit={handleAddVoucher}>
          <div className="form-group">
            <label>Voucher Code</label>
            <input
              type="text"
              name="code"
              value={newVoucher.code}
              onChange={handleInputChange}
              required
              placeholder="Enter voucher code"
            />
          </div>
          <div className="form-group">
            <label>Discount (%)</label>
            <input
              type="number"
              name="discount"
              value={newVoucher.discount}
              onChange={handleInputChange}
              required
              placeholder="Enter discount percentage"
            />
          </div>
          <div className="form-group">
            <label>Expiry Date</label>
            <input
              type="date"
              name="expiryDate"
              value={newVoucher.expiryDate}
              onChange={handleInputChange}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Adding...' : 'Add Voucher'}
          </button>
        </form>
      </div>

      <div className="voucher-list">
        <h2>Voucher List</h2>
        {loading ? (
          <div className="loading">Loading...</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Code</th>
                <th>Discount</th>
                <th>Expiry Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {vouchers.map(voucher => (
                <tr key={voucher.id}>
                  <td>{voucher.code}</td>
                  <td>{voucher.discount}%</td>
                  <td>{new Date(voucher.expiryDate).toLocaleDateString()}</td>
                  <td>
                    <span className={`status-badge ${voucher.status}`}>
                      {voucher.status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="delete-btn"
                        onClick={() => handleToggleStatus(voucher.id, voucher.status)}
                        disabled={loading}
                      >
                        {voucher.status === 'active' ? 'Deactivate' : 'Activate'}
                      </button>
                      <button
                        className="delete-btn"
                        onClick={() => handleDeleteVoucher(voucher.id)}
                        disabled={loading}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Voucher; 